<template>
  <slot />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'BCollectionItem',
  inheritAttrs: false,
})
</script>
